
import { TypedVue } from "@/store/types";
import { Component, Watch, Ref, Prop } from "vue-property-decorator";
import { Modal } from "bootstrap";
import { V2Project } from "@/store/admin/adminTypes";

@Component({})
export default class AddProjectReportModal extends TypedVue {
  @Ref("add-project-report-modal")
  readonly modal!: Modal;

  @Prop() show!: boolean;
  @Prop({ default: null }) project!: V2Project | null;

  @Watch("show")
  onShowChange(show: boolean) {
    if (show) {
      this.modal.show();
    } else {
      this.modal.hide();
    }
  }

  reportTypes = [
    {
      title: "Talent Selection",
      icon: "people",
      iconColour: "#4c7fff",
      description: "Find the right person for the role with comprehensive candidate evaluation",
      features: ["Candidate comparison", "Role fit analysis", "Cultural alignment"],
      action: this.createSearchReport,
    },
    {
      title: "Team Development",
      icon: "graph-up",
      iconColour: "#46c851",
      description: "Understand team dynamics and identify development opportunities",
      features: ["Team strengths mapping", "Gap analysis", "Development recommendations"],
      action: this.createTeamEffectivenessReport,
    },
    {
      title: "Succession Planning",
      icon: "search",
      iconColour: "#ad47ff",
      description: "Identify and prepare future leaders for key positions",
      features: ["Leadership Pipeline", "Readiness assessment", "Development paths"],
      action: this.createTeamEffectivenessReport,
    },
    {
      title: "Leadership Development",
      icon: "star",
      iconColour: "#ef6900",
      description: "Enhance leadership capapilities across your organization",
      features: ["Leadership competencies", "Growth planning", "Coaching insights"],
      action: this.createTeamEffectivenessReport,
    },
    {
      title: "Assisting Due Diligence",
      icon: "file-earmark-text",
      iconColour: "#ef2c37",
      description: "Evaluate leadership teams for investment or aquisition decisions",
      features: ["Executive assessment", "Risk analysis", "Team evaluation"],
      action: this.createTeamEffectivenessReport,
    },
    {
      title: "Evaluation",
      icon: "file-earmark-text",
      iconColour: "#ef2c37",
      description: "Evaluate leadership teams",
      features: ["Executive assessment", "Risk analysis", "Team evaluation"],
      action: this.createEvaluationReport,
    },
  ];

  createSearchReport(): void {
    this.$emit("createSearchReport");
  }

  createTeamEffectivenessReport(): void {
    this.$emit("createTeamEffectivenessReport");
  }

  createEvaluationReport(): void {
    this.$emit("createEvaluationReport");
  }

  close(): void {
    this.$emit("close");
  }
}
